import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFilters } from 'hooks/meetings/filters';
import { defaultFilterParams } from '../constants';
import { BaseState } from './base_state';
import ShruggingBotImgSrc from '../images/shrugging_bot.svg';
const clearFiltersButtonCss = "cpcgnms";
const ClearFiltersButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(clearFiltersButtonCss, props.className)}>
    {I18n.t('publisher.meetings.empty_state.no_results_cta')}
  </Button>);
const queryParserOptions = query => ({
  Bold: () => <strong>{query}</strong>
});
export const EmptyFilteredList = () => {
  const dispatch = useDispatch();
  const {
    applyFilterParams,
    getFilterParams
  } = useFilters();
  const filterParams = getFilterParams();
  const hasQuery = !!filterParams.query;
  const description = hasQuery ? HtmlParser(I18n.t('publisher.meetings.search.results.no_results.description'), queryParserOptions(filterParams.query)) : I18n.t('publisher.meetings.empty_state.no_results_suggestion');
  const onClear = () => {
    dispatch(applyFilterParams(defaultFilterParams));
    dispatch({
      type: 'RESET_FILTER_MODAL'
    });
  };
  return <BaseState heading={I18n.t('publisher.meetings.empty_state.no_results')} description={description} ctaButton={hasQuery ? null : <ClearFiltersButton onClick={() => onClear()} />} imgSrc={ShruggingBotImgSrc} />;
};

require("./empty_filtered_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_filtered_list.js");